import { Routes } from '@angular/router';
import { authGuard, noAuthGuard } from './guards/auth.guard';

export const APP_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.routes').then(m => m.TABS_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then(m => m.AUTH_ROUTES),
    canActivate: [noAuthGuard],
  },
  {
    path: 'unauthorized',
    loadChildren: () => import('./unauthorized/unauthorized.routes').then(m => m.UNAUTHORIZED_ROUTES),
  },
  {
    path: 'offline-qr',
    loadChildren: () => import('./offline-qr-code/offline-qr-code.routes').then(m => m.OFFLINE_QR_CODE_ROUTES),
  },
  {
    // BOA-5491: PRUNEO discovery onboarding, reached via `pruneoOnboardingGuard`'s
    // redirect. Sits outside `/tabs` (no tab bar) but still requires an authenticated
    // beneficiary, hence the same `authGuard`.
    path: 'pruneo-onboarding',
    loadComponent: () => import('./pruneo-onboarding/pruneo-onboarding.page').then(m => m.PruneoOnboardingPage),
    canActivate: [authGuard],
  },
];
